
import XHeader from 'vux/src/components/x-header/index.vue'

import { mapGetters, mapActions } from 'vuex';

export default {
components: {
XHeader
},
name: 'pageheader',
props: [],
data() {
return {
hideback: false
};
},
methods: {
rightClick() {
this.$emit('rightBtn', 'saveinfo');
}
},
watch: {},
computed: {
...mapGetters(['titleText', 'showback', 'rightBtnText', 'navurl', 'leftBtn', 'changeColor', 'rightIcon'])
},
created() {},
mounted() {}
};
